<template>
  <form class="list-search" novalidate @submit.prevent="submit">
    <label class="list-search__label" :for="inputId">{{ label }}</label>
    <div class="list-search__row">
      <input
        :id="inputId"
        v-model="typed"
        type="search"
        class="form-control list-search__input"
        :placeholder="placeholder"
        :maxlength="maxLength"
        :disabled="disabled"
      >
      <button
        type="submit"
        class="btn btn-primary list-search__button"
        :disabled="disabled"
      >探す</button>
      <button
        v-if="applied"
        type="button"
        class="btn btn-outline-secondary list-search__button"
        :disabled="disabled"
        @click="clear"
      >解除</button>
    </div>

    <!--
      **いま絞り込んでいることを、画面に出す。**
      出さないと、探したことを忘れたまま「登録したのに一覧に出ない」と
      なる。件数も絞り込んだ数になるので、なおさら気づけない。
    -->
    <p v-if="applied" class="list-search__applied">
      「<b>{{ applied }}</b>」で絞り込んでいます。
      <span v-if="count !== null">該当 {{ count }} 件。</span>
    </p>
  </form>
</template>

<script>
/**
 * 一覧の絞り込み。
 *
 * ## 一文字ごとには探さない
 *
 * 一覧はサーバでページを切っている。打つたびに問い合わせると、
 * **1文字ごとにページが1へ戻り**、打ち終わる前の結果が後から届いて
 * 上書きすることもある。押したときだけ探す。
 *
 * ## ページは必ず1へ戻す
 *
 * 5ページ目を見ているときに絞り込むと、**絞った結果が1ページしか
 * 無ければ空の表**になる。使う側で currentPage を戻すこと。
 */
export default {
  name: 'ListSearchBox',
  props: {
    /** いま効いている言葉。空なら絞り込んでいない。 */
    value: { type: String, default: '' },
    label: { type: String, default: '絞り込み' },
    placeholder: { type: String, default: '' },
    /** 絞り込んだ結果の件数。null なら出さない。 */
    count: { type: Number, default: null },
    disabled: { type: Boolean, default: false }
  },
  data () {
    return {
      typed: this.value,
      /* サーバ側の上限と同じ。ここだけ長くしても切られる。 */
      maxLength: 100
    }
  },
  computed: {
    /** いま効いている言葉。 */
    applied () {
      return (this.value || '').trim()
    },
    inputId () {
      return 'list-search-' + this._uid
    }
  },
  watch: {
    /** 外から戻されたとき（画面を開き直したときなど）に合わせる。 */
    value (next) {
      this.typed = next
    }
  },
  methods: {
    submit () {
      this.$emit('search', (this.typed || '').trim())
    },
    clear () {
      this.typed = ''
      this.$emit('search', '')
    }
  }
}
</script>

<style scoped>
.list-search { margin-bottom: 16px; }

.list-search__label {
  display: block;
  margin-bottom: 4px;
  color: #6f8190;
  font-size: 12px;
}

.list-search__row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.list-search__input {
  flex: 1 1 260px;
  min-width: 180px;
  max-width: 420px;
}

.list-search__button { white-space: nowrap; }

.list-search__applied {
  margin: 8px 0 0;
  color: #6f8190;
  font-size: 13px;
}

@media (max-width: 575.98px) {
  .list-search__input { flex-basis: 100%; max-width: none; }
}
</style>
